import React, { Component } from 'react';
import { observer } from 'mobx-react';
import ScrollArea from 'react-scrollbar';
import './PlayList.css';

import { DataStore } from '../DataStore';

@observer
class PlayList extends Component {
    onClickRemoveIcon = (event) => {
        let hash = event.target.getAttribute('hash');
        DataStore.removeInSongList(hash);
    }

    onClickPlayIcon = (event) => {
        let hash = event.target.getAttribute('hash');
        let index = DataStore.findInPlayList(hash);
        DataStore.count = index;
        DataStore.isPlay = true;
    }

    onClearSongList = (event) => {
        DataStore.clearSongList();
    }

    ListItems = (list) => {
        //console.log(list);
        if(list.length > 0) {
            let listItems = [];
            for (let i = 0; i < list.length; i++) {
                listItems.push(
                    <ul className={"play-list-row" + (i === DataStore.count ? ' cur' : '')}
                        key={list[i].Hash}>
                        <li className="sort">{i + 1}</li>
                        <li className="song-name ell">{list[i].SongName}</li>
                        <li className="singer-name ell">{list[i].SingerName}</li>
                        <li className="operate">
                            <button className="iconfont icon-remove"
                                hash={list[i].Hash}
                                onClick={this.onClickRemoveIcon}></button>
                            <button className="iconfont icon-play"
                                hash={list[i].Hash}
                                onClick={this.onClickPlayIcon}></button>
                        </li>
                    </ul>
                )
            }
            return (<div className="play-list-body"
                        style={{height:DataStore.scrollHeight + 'px'}}>
                        <ScrollArea
                            horizontal={false}>
                            {listItems}
                        </ScrollArea>
                    </div>); 
        }else{
            return (<div className="play-list-body">暂无数据</div>);
        }
    }

    render() {
        return (
            <div className={"play-list-box" + (DataStore.showPlayList ? '' : ' hide')}>
                <h1>我的歌曲播放列表</h1>
                <div className="play-list-header">
                    <ul className="play-list-row">
                        <li className="sort"></li>
                        <li className="song-name">歌曲</li>
                        <li className="singer-name">歌手</li>
                        <li className="operate">
                            <button className="iconfont icon-trash"
                                onClick={this.onClearSongList}></button>
                        </li>
                    </ul>
                </div>
                {this.ListItems(DataStore.playSongList.slice())}
            </div>
        );
    }

}

export default PlayList;


// WEBPACK FOOTER //
// ./src/components/PlayList.js